import {DataObjectId, Hub, noBoardContainerId} from 'yougile-model'
import {getColumnTimeInterval} from '@components/sticker/my-stickers/board-stickers/sticker-settings/stopwatch/stopwatch-column-utils'
import {getTimerValue} from '@components/task-timeline/get-timer-value'

export const getTimeInColumn = (task: Hub): number | undefined => {
  const columnId = task.location
  if (columnId === noBoardContainerId) {
    return undefined
  }
  const columnTimeInterval = getColumnTimeInterval(task, getTimerValue(task))
  const interval = columnTimeInterval.find(el => el.column?.id === columnId)
  if (!interval) {
    return undefined
  }

  const {timeBegin, timeEnd} = interval

  return timeEnd - timeBegin
}

type TasksIntervals = {[taskId: DataObjectId]: number | undefined}

const getTasksIntervals = (tasks: Hub[]): TasksIntervals => {
  return tasks.reduce((acc, task) => {
    const time = getTimeInColumn(task)
    acc[task.id] = time
    return acc
  }, {} as TasksIntervals)
}

export const sortByTimeInColumnNew = (tasks: Hub[]): Hub[] => {
  const intervals = getTasksIntervals(tasks)

  return tasks.sort((b, a) => {
    const aData = intervals[a.id]
    const bData = intervals[b.id]

    if (aData && bData) {
      return bData - aData
    }

    if (aData) {
      return 1
    }

    if (!aData && !bData) {
      return 0
    }

    return -1
  })
}

export const sortByTimeInColumnOld = (tasks: Hub[]): Hub[] => {
  const intervals = getTasksIntervals(tasks)

  return tasks.sort((b, a) => {
    const aData = intervals[a.id]
    const bData = intervals[b.id]

    if (aData && bData) {
      return aData - bData
    }

    if (aData) {
      return 1
    }

    if (!aData && !bData) {
      return 0
    }

    return -1
  })
}
